// CheerpX licence notice (blocking, shown before the runtime is ever requested) and the per-browser
// acceptance record. Wording adapted from EndisOS src/linux/cheerpx/notice-text.ts.
import { readJSON, writeJSON } from "../../shared/store.js";
import { CHEERPX_KEY } from "../../shared/linux-store.js";
import { CHEERPX_RUNTIME_URL } from "../../shared/linux-catalog.js";

export const NOTICE_HEADING = "CheerpX runtime";
export const NOTICE_TEXT = "This machine loads the CheerpX runtime from Leaning Technologies' servers (cxrtnc.leaningtech.com) under the CheerpX Community License, and streams its disk image from Leaning's WebVM disk service (disks.webvm.io). The Community License is free for individuals, open-source projects and technical evaluations; business use in production, self-hosting the runtime and redistribution need a commercial license. Some uses are prohibited by the license (see its terms). Re:Vault does not host, modify or redistribute CheerpX. The runtime and disk need an internet connection; nothing here works offline. Your machine's disk changes are stored in this browser.";
export const NOTICE_CHECKBOX = "I have read the CheerpX Community License terms and confirm my use is permitted";
export const NOTICE_LINKS = [
	["CheerpX licensing", "https://cheerpx.io/docs/licensing"],
	["Community License text", "https://github.com/leaningtech/cheerpx-meta/blob/main/LICENSE.txt"],
	["cheerpx.io", "https://cheerpx.io/"],
];
export const ATTRIBUTION = "Powered by CheerpX (Leaning Technologies) and xterm.js.";

export function isAcceptance(r) {
	return !!r && typeof r === "object" && typeof r.accepted === "boolean" && typeof r.acceptedAt === "number" && Number.isFinite(r.acceptedAt) && typeof r.runtimeUrl === "string" && r.runtimeUrl.length <= 4096;
}
// Acceptance is tied to the runtime URL it was given for: a runtime bump asks again.
export function readAcceptance() {
	const r = readJSON(CHEERPX_KEY, null);
	return isAcceptance(r) && r.accepted && r.runtimeUrl === CHEERPX_RUNTIME_URL ? r : null;
}
export function writeAcceptance(accepted) {
	writeJSON(CHEERPX_KEY, { accepted: !!accepted, acceptedAt: accepted ? Date.now() : 0, runtimeUrl: CHEERPX_RUNTIME_URL });
}
